import { useState, useEffect, useCallback } from 'react'
import './index.scss'

const pad = (n) => String(n).padStart(2, '0')

const ProjectModal = ({ project: p, onClose }) => {
  const [img, setImg] = useState(0)
  const gallery = p?.imageBank || (p?.image ? [p.image] : [])
  const hasGallery = gallery.length > 1

  const next = useCallback((e) => { e?.stopPropagation(); setImg(i => (i + 1) % gallery.length) }, [gallery.length])
  const prev = useCallback((e) => { e?.stopPropagation(); setImg(i => (i - 1 + gallery.length) % gallery.length) }, [gallery.length])

  useEffect(() => {
    setImg(0)
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = '' }
  }, [p])

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
      else if (e.key === 'ArrowRight') next()
      else if (e.key === 'ArrowLeft') prev()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose, next, prev])

  if (!p) return null

  const statusColor = p.status === 'LIVE' ? '#4ade80' : 'rgba(238,241,246,0.4)'

  return (
    <div className='pm-backdrop' onClick={onClose}>

      {/* ── Left: image area ────────────────────────────── */}
      <div className='pm-left' onClick={(e) => e.stopPropagation()}>
        <div className='pm-img-wrap'>
          {gallery[img]
            ? <img src={gallery[img]} alt={p.title} className='pm-img' />
            : <div className='pm-img-placeholder'>{p.title}</div>
          }
        </div>

        {hasGallery && (
          <>
            <button className='pm-nav pm-nav--prev' onClick={prev}>‹</button>
            <button className='pm-nav pm-nav--next' onClick={next}>›</button>
            <div className='pm-counter'>{pad(img + 1)} / {pad(gallery.length)}</div>
          </>
        )}
      </div>

      {/* ── Right: detail panel ─────────────────────────── */}
      <div className='pm-panel' onClick={(e) => e.stopPropagation()}>
        <button className='pm-close' onClick={onClose}>✕</button>

        <div className='pm-kind'>{p.kind}</div>
        <h2 className='pm-title'>{p.title}</h2>
        <p className='pm-subtitle'>{p.description}</p>

        <div className='pm-status-row'>
          <a className='pm-status' href={p.live} target='_blank' rel='noopener noreferrer'>
            <span className='pm-status__dot' style={{ background: statusColor }} />
            {p.status || 'LIVE'}
          </a>
          {p.github && (
            <a className='pm-status pm-status--ghost' href={p.github} target='_blank' rel='noopener noreferrer'>
              GitHub ↗
            </a>
          )}
        </div>

        <div className='pm-divider'>
          <span className='pm-divider__label'>Details</span>
          <span className='pm-divider__line' />
        </div>

        <p className='pm-details'>{p.details}</p>
      </div>

    </div>
  )
}

export default ProjectModal
